// components/SocialShare.tsx
import styles from "./social.module.css";
import { SVG } from "@/assets/svg";
import React from "react";
import {
  WhatsappShareButton,
  FacebookShareButton,
  TwitterShareButton,
  EmailShareButton,
} from "react-share";
import { errorToast, successToast } from "../toasts";
import { useRouter } from "next/router";
interface IProps {
  handleShare?: () => void;
  customShareUrl?: string;
  customTitle?: string;
  type?: string;
}

const SocialShare: React.FC<IProps> = ({
  handleShare,
  customShareUrl,
  customTitle,
  type,
}) => {
  const router = useRouter();
  let id, shareUrl: any, title;
  if (type === "collection") {
    id = router.query?.id || router.query?.slug;
    shareUrl =
      customShareUrl || window.location.origin + "/collection-view/" + id;
    title = customTitle || "Check out this amazing collection!";
  } else {
    id = router.query?.slug || router.query?.id;
    shareUrl =
      customShareUrl || window.location.origin + "/minerals/" + id;
    title = customTitle || "Check out this amazing mineral!";
  }

  const handleCopy = () => {
    try {
      navigator.clipboard.writeText(shareUrl);
      successToast("Link copied to clipboard");
      handleShare && handleShare();
    } catch (error) {
      errorToast("Cannot access clipboard on unsecure sites (required https)");
    }
  };

  return (
    <>
      <div className="SocialShareLayout">
        <h6 className={`${styles.Share}`}>Share</h6>
        <div>
          <WhatsappShareButton
            onClick={handleShare}
            url={shareUrl}
            title={title}
          >
            <div className={`${styles.icon}`}>
              <SVG.Six width="60px" />
              <p> WhatsApp</p>
            </div>
          </WhatsappShareButton>
          <FacebookShareButton
            onClick={handleShare}
            url={shareUrl}
            title={title}
          >
            <div className={`${styles.icon}`}>
              <SVG.Seven width="60px" />
              <p> Facebook</p>
            </div>
          </FacebookShareButton>

          <TwitterShareButton
            onClick={handleShare}
            url={shareUrl}
            title={title}
          >
            <div className={`${styles.icon}`}>
              <SVG.Eight width="60px" />
              <p>Twitter</p>
            </div>
          </TwitterShareButton>

          <EmailShareButton
            // onClick={handleShare}
            url={shareUrl}
            subject={title}
            // body={shareUrl}
          >
            <div onClick={handleShare} className={`${styles.icon}`}>
              <SVG.Nine width="60px" />
              <p>Email</p>
            </div>
          </EmailShareButton>
        </div>

        <div style={{ margin: "10px" }}>
          <div
            className={`${styles.copy}`}
            style={{
              cursor: "copy",
            }}
          >
            {typeof window !== "undefined" && shareUrl}
          </div>
          <button onClick={handleCopy} className={`${styles.copyLink}`}>
            Copy
          </button>
        </div>
      </div>
    </>
  );
};

export default SocialShare;
